<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-30 19:17:32
 * @FilePath: /wemeet-admin-new/src/views/exhibitionManage/components/holdMeetRegister.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    title="报名方式配置"
  >
    <div class="containerForm">
      <el-form v-for="(item, index) in identityList" :key="index" :model="item">
        <el-form-item :label="item.identityName" />
        <el-form-item label="是否开启报名">
          <el-switch v-model="item.isOpenSignUp" active-text="开启" inactive-text="关闭" />
        </el-form-item>

        <el-form-item label="报名方式	">
          <el-select v-model="item.signUpStyle" placeholder="报名方式">
            <el-option v-for="sitem in options" :key="sitem.value" :label="sitem.label" :value="sitem.value" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="save(item)">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="demo-drawer__footer">

    </div> -->
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getRegisterConfigListAdmin, updateRegisterConfig } from '@/api/exhibitionManage'
  export default defineComponent({
    name: 'UserDetail',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        form: {},
        identityList: [],
        options: [
          {
            value: 'FORM',
            label: '表单',
          },
          {
            value: 'NO_SIGN_UP',
            label: '无报名',
          },
        ],
      })
      // 打开
      const handleOpen = async (row) => {
        state.row = row
        state.dialogFormVisible = true

        const { data } = await getRegisterConfigListAdmin(row.meetingCode)
        console.log(data)
        state.identityList = data
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const save = async (item) => {
        try {
          const { data } = updateRegisterConfig(item)
          proxy.$baseMessage(`更新成功`, 'success', 'vab-hey-message-success')
          // handleClose()
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        save,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
